module.exports = __webpack_public_path__ + "static/media/SVID_Z_1.3896cd1a.png";